import { render } from "./ModeSwitcher.vue?vue&type=template&id=cc8a2888&scoped=true"
import script from "./ModeSwitcher.vue?vue&type=script&lang=js"
export * from "./ModeSwitcher.vue?vue&type=script&lang=js"

import "./ModeSwitcher.vue?vue&type=style&index=0&id=cc8a2888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc8a2888"]])

export default __exports__